import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { DateTime } from 'luxon';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AssetConfigurationsDTO, ProductAssetClient } from 'src/app/base/models/models.swagger.generated';

@Injectable({
  providedIn: 'root'
})
export class AssetConfigurationsService {
  public assetConfiguration: AssetConfigurationsDTO;

  private _lastUpdated: DateTime;
  constructor(private productAssetClient: ProductAssetClient) { }

  // will be called by resolver
  public loadAssetConfigurations(): Observable<AssetConfigurationsDTO> {
    if (this.assetConfiguration && this._lastUpdated && this._lastUpdated.plus({ days: 1 }) > DateTime.now()) {
      return of(this.assetConfiguration);
    }
    return this.productAssetClient.getAssetConfigurations().pipe(
      tap((assetConfigurations: AssetConfigurationsDTO) => {
        this.assetConfiguration = assetConfigurations;
        this._lastUpdated = DateTime.now();
      }
    ));
  }
}

export const assetConfigurationsResolver: ResolveFn<AssetConfigurationsDTO> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return inject(AssetConfigurationsService).loadAssetConfigurations();
};
